import type { TicketTemplateId } from "../types/rsvp";

const TEMPLATE_ORDER: TicketTemplateId[] = ["black", "white"];

export function neighborTicketTemplateId(id: TicketTemplateId, dir: -1 | 1): TicketTemplateId {
  const idx = TEMPLATE_ORDER.indexOf(id);
  return TEMPLATE_ORDER[(idx + dir + TEMPLATE_ORDER.length) % TEMPLATE_ORDER.length];
}
